import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawFirmPopoverInfos } from '../lawFirm.types';
import { LawFirmCardTitle } from '../card/LawFirmCardTitle';
import { UserContext } from '../../user/UserContext';
import { EntitiesCardFooter } from '../../components/entities-card/EntitiesCardFooter';
import { EntitiesCardBody } from '../../components/entities-card/EntitiesCardBody';
import { LawFirmOffices } from './LawFirmOffices';
import { LawFirmDetails } from './LawFirmDetails';
import { EntitiesList } from '../../components/entities-card/EntitiesList';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';

type Props = {
  lawFirm: LawFirmPopoverInfos;
  source: string;
};

export const LawFirmCard: FC<Props> = ({ lawFirm, source }) => {
  const { accessPremium } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();

  const handleClick = (newSource: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source: newSource });
    }
  };

  return (
    <>
      <EntitiesCardBody>
        <LawFirmCardTitle
          href={
            accessPremium ? `${lawFirm.url}?source=${source}-header` : undefined
          }
          onClick={handleClick(`${source}-header`)}
        >
          {lawFirm.name}
        </LawFirmCardTitle>
        <EntitiesList>
          {lawFirm.offices.length > 0 && (
            <LawFirmOffices
              lawFirm={lawFirm}
              source={source}
              accessPremium={accessPremium}
            />
          )}
          {lawFirm.offices.length === 0 && <LawFirmDetails lawFirm={lawFirm} />}
        </EntitiesList>
      </EntitiesCardBody>
      {lawFirm && lawFirm.url && (
        <EntitiesCardFooter
          href={
            accessPremium ? `${lawFirm.url}?source=${source}-footer` : undefined
          }
          onClick={handleClick(`${source}-footer`)}
        >
          <FormattedMessage id="law-firm/popover/LawFirmCard.tsx/1" />
        </EntitiesCardFooter>
      )}
    </>
  );
};
